import Vue from 'vue'
import Vuex from 'vuex'
import sidebar from "./modules/sidebar"
import navbar from "./modules/navbar"
import modals from "./modules/modals"
import auth from "./modules/auth"
import contents from "./modules/contents"
import check from "./modules/check"
import user from "./modules/user"
import facebook from "./modules/facebook"
import dashboard from "./modules/dashboard"
import support from "./modules/support";
import screen from "./modules/screen";
import notifications from "./modules/notifications";
import createMutationsSharer from "vuex-shared-mutations";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        sidebar, modals, auth, contents, check, 
        user, facebook, dashboard, support, navbar, screen,
        notifications
    },
    plugins: [createMutationsSharer({predicate: ["auth_success", "logout"]})]

})
